import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
    
    root: {
      backgroundColor: '#F7FAFF',
    },
  
    mainContainer: {
      display: 'flex',
      gap: theme.spacing(2),
      padding: theme.spacing(3),
      paddingTop: theme.spacing(10),
    },
  
    titleDiv: {
      display: 'flex',
      width: '50%',
      justifyContent: 'right',
    },
  
    titleIcon: {
      borderRadius: '7px',
      width:'40px',
      height:'40px',
      backgroundColor: '#6179D3',
      padding: theme.spacing(0.5),
      fill: theme.palette.secondary.main,
      right:theme.spacing(2),
    },
  
    leftTitle: {
     width: '50%',
     color: 'gray',
    },
  
    activitiesTab: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      '& .MuiTabs-indicator': {
        display:'none',
      },
    },
  
    activitiesTabButtons: {
      backgroundColor: '#fff',
      borderRadius: '30px',
      boxShadow: ' 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.10)',
      padding: theme.spacing(0.5),
      minHeight: '10px',
      '& button': {
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        minHeight: '10px',
      },
      '& .Mui-selected': {
        backgroundColor:theme.palette.primary.main,
        borderRadius: '30px',
        color:'#fff',
        border: '0 px solid'
      },
    },
  
    activitiessTabPanel: {
  
    },
  
    graphDetails: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'sticky',
      height: '90px',
      '& li': {
        padding:theme.spacing(0.5),
      },
    },
  
    graphContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      marginBottom: theme.spacing(3),
      alignItems: 'center',
      position: 'sticky',
      height: '120px',
    },
  
    grayGraph: {
      color: '#dddddd',
      position: 'absolute',
    },
  
    workGraph: {
      color: '#6179D3',
      position: 'absolute',
    },
  
    pauseGraph: {
      color: '#ffc465',
      position:'absolute',
    },
  
    restGraph: {
      color: '#FD7C57',
      position:'absolute',
    },
  
    otherGraph: {
      color: '#AEA4E3',
      position:'absolute',
    },
  
    graphDivider: {
      display: 'inline-block',
      width: '50%',
      height: '0',
    },
  
    circle: {
      width: '10px',
      height: '10px',
      alignItems: 'center',
      borderRadius: '50%',
      marginRight: theme.spacing(2),
    },
  
    graphTimers: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'sticky',
      fontSize: '7pt',
    },
  
    timeContainer: {
      display: 'flex',
      gap: theme.spacing(1),
      padding: theme.spacing(3),
    },

    timerTab: {
      width: '100%',
      display: 'flex',
      padding:theme.spacing(1),
      justifyContent: 'center',
      '& .MuiTabs-indicator': {
        display:'none',
      },
    },
  
    timerTabButtons: {
      borderRadius: '30px',
      padding: theme.spacing(0.5),
      '& svg': {
        width:'25px',
        height:'25px',
      },
      '& button': {
        padding: '0!important',
        boxShadow: ' 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.10)',
        backgroundColor: '#fff',
        marginRight: theme.spacing(2),
        borderRadius: '30px',
        minHeight:'10px',
        minWidth:'80px',
        lineHeight:'0',
        fill: theme.palette.neutral.main,
      },
      '& .Mui-selected': {
        backgroundColor:theme.palette.primary.main,
        fill: theme.palette.secondary.main,
        border: '0 px solid'
      },
    },

    verticalLineGraphs: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'sticky',
      marginBottom: theme.spacing(0),
    },

    verticalLineList: {
      display: 'flex',
      width: '100%',
      paddingBottom: theme.spacing(22),      
      position: 'sticky',
      fontSize: '7pt',
      height:'100px',
      ['& div']:{
        marginTop:'230px',
        width:'10px',
        display: 'sticky',
        textAlign: 'center',
      }
    },

    verticalLine: {
      width:'100px',
      height:'7px',
      borderRadius: '30px',
      
      position: 'absolute',
    }
  
  }));